    export interface IAccountNote {
        title: string;
        value: string;
        createDate: Date;
        createBy: string;
        isCritical: boolean;
        noteType: string;
        createByGroup: string;
    }

    export class AccountNote implements IAccountNote {
        createByGroup: string;
        title: string;
        value: string;
        createDate: Date;
        createBy: string;
        isCritical: boolean;
        noteType: string;
    }